import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./login.css";
const LoginForm = () => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();
    // Handle input changes
    const handleNameChange = (e) => setName(e.target.value);
    const handlePhoneChange = (e) => setPhone(e.target.value);

    // Validate the name
    const validateName = (name) => {
        return name.length <= 20;
    };

    // Validate the phone number
    const validatePhone = (phone) => {
        const phoneRegex = /^[6789]\d{9}$/; // Starts with 6,7,8,9 and followed by 9 digits
        return phoneRegex.test(phone);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Reset errors
        setError('');

        // Validate inputs
        if (!validateName(name)) {
            setError('Name must be 20 characters or less');
            return;
        }

        if (!validatePhone(phone)) {
            setError('Invalid Phone number');
            return;
        }

        setLoading(true);

        // Prepare data to send to the backend
        const userData = { name, phone };

        try {
            // Example: Send data to your backend API
            const response = await fetch('https://swarna-herbal-backend.onrender.com/api/userLogin/add', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            });

            if (response.ok) {
                const data = await response.json();
                console.log("response", data.user);
                // Store user details in localStorage
                localStorage.setItem('userDetails', JSON.stringify(data.user));
                navigate("/");
            } else {
                setError('Failed to login. Please try again.');
            }
        } catch (err) {
            setError('Error occurred while connecting to the server.');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userDetails"));
        if (user) {
            setName(user.name);
            setPhone(user.phone);
            console.log("user from local storage", user);
        }
    }, []);
    return (
        <div className='login-main-container'>
            <div className="login-container" style={{ maxWidth: '400px', margin: '0 auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
                <h2>Login</h2>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '15px' }}>
                        <label htmlFor="name">Enter Your Name:</label>
                        <input
                            type="text"
                            id="name"
                            value={name}
                            onChange={handleNameChange}
                            placeholder="Enter your name"
                            style={{ width: '100%', padding: '8px', marginTop: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                        />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label htmlFor="phone">Enter Your Phone Number:</label>
                        <input
                            type="text"
                            id="phone"
                            value={phone}
                            onChange={handlePhoneChange}
                            placeholder="Enter your phone number"
                            maxLength={10}
                            style={{ width: '100%', padding: '8px', marginTop: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                        />
                    </div>

                    {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            padding: '10px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                        }}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>

    );
};

export default LoginForm;
